<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 59.1 (86144) - https://sketch.com -->
    <title>Icons/fonctionnels/ic_export</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Icons/fonctionnels/ic_export"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <path
        id="ic_export"
        d="M12,0 C18.6274286,0.00114285714 24,5.37257143 24,12 C24,18.6285714 18.6274286,24 12,24 C5.37142857,24 0,18.6285714 0,12 C0,5.37257143 5.37142857,0.00114285714 12,0 Z M12,1.14285714 C9,1.14285714 6.28914286,2.35771429 4.32228571,4.32228571 C2.35771429,6.28914286 1.14285714,9 1.14285714,12 C1.14285714,15 2.35771429,17.7108571 4.32228571,19.6777143 C6.28914286,21.6434286 9,22.8571429 12,22.8571429 C15,22.8571429 17.7108571,21.6434286 19.6777143,19.6777143 C21.6434286,17.7108571 22.8571429,15 22.8571429,12 C22.8571429,9 21.6434286,6.28914286 19.6777143,4.32228571 C17.7108571,2.35771429 15,1.14285714 12,1.14285714 Z M12.7645714,7.1576 C12.9874286,6.93474286 13.3497143,6.93474286 13.5725714,7.1576 L13.5725714,7.1576 L17.9874286,11.5736 C18.04,11.6273143 18.0822857,11.6901714 18.1108571,11.7598857 C18.1348571,11.8170286 18.1428571,11.8764571 18.1474286,11.9370286 C18.1474286,11.9484571 18.1531429,11.9587429 18.1542857,11.9701714 C18.1542857,11.9736 18.1554286,11.9758857 18.1554286,11.9781714 L18.1554286,11.9781714 L18.1531429,11.9884571 L18.1531429,11.9884571 L18.1474286,12.0204571 C18.1428571,12.0810286 18.1337143,12.1404571 18.1108571,12.1964571 C18.0822857,12.2673143 18.04,12.3301714 17.9874286,12.3827429 L17.9874286,12.3827429 L13.5737143,16.7964571 C13.3508571,17.0193143 12.9885714,17.0193143 12.7657143,16.7964571 C12.5428571,16.5736 12.5428571,16.2113143 12.7657143,15.9884571 L12.7657143,15.9884571 L16.2045714,12.5496 L6.41485714,12.5496 C6.09942857,12.5496 5.84342857,12.2936 5.84342857,11.9781714 C5.84342857,11.6627429 6.09942857,11.4067429 6.41485714,11.4067429 L6.41485714,11.4067429 L16.2045714,11.4067429 L12.7645714,7.9656 C12.5417143,7.74274286 12.5417143,7.3816 12.7645714,7.1576 Z"
        fill="#454545"
      ></path>
    </g>
  </svg>
</template>

<script>
export default {
  name: "Export",
}
</script>
